import { render, staticRenderFns } from "./collect-card.vue?vue&type=template&id=17089e72&"
import script from "./collect-card.vue?vue&type=script&lang=js&"
export * from "./collect-card.vue?vue&type=script&lang=js&"
import style0 from "./collect-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports